export const POST_PAYMENT = "paymentLink";
export const GET_PAYMENT_PAGE_DETAILS = "paymentPage";
